export default __webpack_public_path__ + "static/media/Ingredient Hunt.ff8eea6a.png";